import BannerCarousel from '@components/BannerCarousel'
import baseClasses from '@components/Themes/layout.module.scss'
import WhatsApp from '@components/WhatsApp'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Hidden from '@mui/material/Hidden'
import Typography from '@mui/material/Typography'
import { loadCardsdestinos, searchCardsdestinos } from '@store/actions/cardsdestinosActions'
import { loadCardsinstagram, searchCardsinstagram } from '@store/actions/cardsinstagramActions'
import { loadCardspartners, searchCardspartners } from '@store/actions/cardspartnersActions'
import { loadCardstourdesks, searchCardstourdesks } from '@store/actions/cardstourdesksActions'
import { IState } from '@store/reducers/index'
import dashboardmodulescss from 'dist/css/dashboard.module.scss'
import React, { FunctionComponent } from 'react'
import CountUp from 'react-countup'
import { Helmet } from 'react-helmet'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Parallax } from 'react-parallax'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import 'swiper/css/bundle'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'

const Dashboard: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const allCardsInstagram = useSelector((state: IState) => state.cardsinstagram).cardsinstagram
  const cardsinstagramData = useSelector((state: IState) => state.cardsinstagram)
  const allCardsTourDesks = useSelector((state: IState) => state.cardstourdesks).cardstourdesks
  const cardstourdesksData = useSelector((state: IState) => state.cardstourdesks)
  const [allCardsPartnersSection, setallCardsPartnersSection] = React.useState<any>([])
  const allCardsPartners = useSelector((state: IState) => state.cardspartners).cardspartners
  const cardspartnersData = useSelector((state: IState) => state.cardspartners)
  const [displayedPosts, setdisplayedPosts] = React.useState<any>([])
  const allCardsDestinos = useSelector((state: IState) => state.cardsdestinos).cardsdestinos
  const cardsdestinosData = useSelector((state: IState) => state.cardsdestinos)
  const [iFrameCasino, setiFrameCasino] = React.useState<any>(false)
  const [iFrameMapa, setiFrameMapa] = React.useState<any>(false)
  const [locat, setlocat] = React.useState<any>({ latitude: -30, longitude: -70 })
  const theme = { ...baseClasses, ...dashboardmodulescss }
  const dispatch = useDispatch()
  const [LoadfromDatabaseCardsDestinosloadoptions, setLoadfromDatabaseCardsDestinosloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseCardsDestinosload = (options) => {
    dispatch(options.searchString ? searchCardsdestinos(options) : loadCardsdestinos(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseCardsDestinosload({
      ...LoadfromDatabaseCardsDestinosloadoptions,
    })
  }, [LoadfromDatabaseCardsDestinosloadoptions])
  const [LoadfromDatabaseCardsPartnersloadoptions, setLoadfromDatabaseCardsPartnersloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseCardsPartnersload = (options) => {
    dispatch(options.searchString ? searchCardspartners(options) : loadCardspartners(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseCardsPartnersload({
      ...LoadfromDatabaseCardsPartnersloadoptions,
    })
  }, [LoadfromDatabaseCardsPartnersloadoptions])
  const [LoadfromDatabaseloadoptions, setLoadfromDatabaseloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseload = (options) => {
    dispatch(options.searchString ? searchCardstourdesks(options) : loadCardstourdesks(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseload({
      ...LoadfromDatabaseloadoptions,
    })
  }, [LoadfromDatabaseloadoptions])
  const [LoadfromDatabaseallCardsInstagramloadoptions, setLoadfromDatabaseallCardsInstagramloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseallCardsInstagramload = (options) => {
    dispatch(options.searchString ? searchCardsinstagram(options) : loadCardsinstagram(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseallCardsInstagramload({
      ...LoadfromDatabaseallCardsInstagramloadoptions,
    })
  }, [LoadfromDatabaseallCardsInstagramloadoptions])

  // Theme selection

  React.useEffect(() => {
    if (cardsdestinosData.loadingStatus === 'loaded') {
    }
  }, [cardsdestinosData.loadingStatus])

  React.useEffect(() => {
    if (cardspartnersData.loadingStatus === 'loaded') {
    }
  }, [cardspartnersData.loadingStatus])

  React.useEffect(() => {
    if (cardsinstagramData.loadingStatus === 'loaded') {
      console.log('allCardsInstagram:', allCardsInstagram)
    }
  }, [cardsinstagramData.loadingStatus])

  return (
    <React.Fragment>
      <div className={theme.pages}>
        <WhatsApp />

        <Helmet>
          <title>Real Travel App</title>
          <meta name="description" content="BUSCA, ENCUENTRA, VIVE TU DESTINO." />
          <meta name="title" property="og:title" content="Real Travel App" />
          <meta name="image" property="og:image" content="https://realtravelapp.com/img/favicon.ico"></meta>
          <meta name="og:url" content="https://realtravelapp.com" />
          <meta name="google-site-verification" content="7RHpk-2jokFO-voVo634Mx5kanFZSj3HptuSG22kwBM" />

        </Helmet>

        <div data-title="TopPage" className={theme.topPage}>
          <BannerCarousel />
        </div>

        <div data-title="Explora El Mundo" className={theme.exploraElMundo}>
          <Container className={theme.containerExplora} maxWidth="xl">
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h1">
                EXPLORA
                <span className={theme.titleRedLigth}>EL MUNDO</span>
              </Typography>

              <Typography variant="body1">
                Desde las majestuosas maravillas naturales, hasta los animados centros urbanos: nuestra aplicación te prepara para vivir momentos
                inolvidables.
              </Typography>
            </div>

            <div data-title="Percentage Section" className={theme.percentageSection}>
              <div data-title="items Paises" className={theme.items}>
                <div data-title="itemSuperior" className={theme.itemSuperior}>
                  <Typography variant="h6">
                    <CountUp end={9} duration={7} delay={3} separator="." className={theme.countUp} />
                  </Typography>
                </div>

                <div data-title="itemInferior" className={theme.itemInferior}>
                  <Typography variant="body1">Países</Typography>
                </div>
              </div>

              <div data-title="items Destinos" className={theme.items}>
                <div data-title="itemSuperior" className={theme.itemSuperior}>
                  <Typography variant="h6">
                    +
                    <CountUp end={250} duration={7} delay={3} separator="." className={theme.countUp} />
                  </Typography>
                </div>

                <div data-title="itemInferior" className={theme.itemInferior}>
                  <Typography variant="body1">Destinos</Typography>
                </div>
              </div>

              <div data-title="items Puntos de interés" className={theme.items}>
                <div data-title="itemSuperior" className={theme.itemSuperior}>
                  <Typography variant="h6">
                    +
                    <CountUp end={22000} duration={7} delay={2} separator="." className={theme.countUp} />
                  </Typography>
                </div>

                <div data-title="itemInferior" className={theme.itemInferior}>
                  <Typography variant="body1">Puntos de interés</Typography>
                </div>
              </div>

              <div data-title="items Usuarios" className={theme.items}>
                <div data-title="itemSuperior" className={theme.itemSuperior}>
                  <Typography variant="h6">
                    +
                    <CountUp end={11300} duration={7} delay={2} separator="." className={theme.countUp} />
                  </Typography>
                </div>

                <div data-title="itemInferior" className={theme.itemInferior}>
                  <Typography variant="body1">Usuarios</Typography>
                </div>
              </div>
            </div>
          </Container>
        </div>

        <div data-title="Nuestros Servicios" className={theme.nuestrosServicios}>
          <Container className={theme.containerServicios} maxWidth="xl">
            <div data-title="Title " className={theme.titleWhite}>
              <Typography variant="h1">
                <span className={theme.titleRedLigth}>NUESTROS</span>
                SERVICIOS
              </Typography>
            </div>

            <div data-title="Servicios" className={theme.seccionServicios}>
              <div data-title="div territorios" className={theme.cardServicios}>
                <NavLink to="/JoinUs#videosDeYT">
                  <picture className={theme.cardServicioImg}>
                    <img src="/img/ServiciosParques.png" alt="/img/ServiciosParques.png" />
                  </picture>
                </NavLink>

                <Typography variant="h6">Digitalización de territorios</Typography>

                <span className={theme.swiperSlideText}>
                  Actualiza tu oficina de información turística con información verificada y actualizada en tiempo real.
                </span>
              </div>

              <div data-title=" lineaDivisora div" className={theme.lineaDivisora}></div>

              <div data-title="div parques" className={theme.cardServicios}>
                <NavLink to="/JoinUs#videosDeYT">
                  <picture className={theme.cardServiciosImg}>
                    <img src="/img/ServicioTerritorios.png" alt="/img/ServicioTerritorios.png" />
                  </picture>
                </NavLink>

                <Typography variant="h6">Digitalización de parques</Typography>

                <span className={theme.swiperSlideText}>
                  ¡Un QR es suficiente para explorar! Obtén tu mapa 100% personalizado, para que tod@s puedan conocer la atracción que ofreces,
                  incluso a través de audioguía en caso de que sea necesario.
                </span>
              </div>

              <div data-title=" lineaDivisora div" className={theme.lineaDivisora}></div>

              <div data-title="div comercios" className={theme.cardServicios}>
                <NavLink to="/JoinUs#videosDeYT">
                  <picture className={theme.cardServiciosImg2left}>
                    <img src="/img/ServiciosEventos.png" alt="/img/ServiciosEventos.png" />
                  </picture>
                </NavLink>

                <Typography variant="h6">Digitalización de comercio</Typography>

                <span className={theme.swiperSlideText}>
                  Queremos que tu comercio lo conozcan muchas personas y que muchos visitantes disfruten de la experiencia que ofreces. ¡Consigue
                  mayor visibilidad por medio de Real Travel App!
                </span>
              </div>

              <div data-title=" lineaDivisora div" className={theme.lineaDivisora}></div>

              <div data-title="div Eventos" className={theme.cardServicios}>
                <NavLink to="/JoinUs#videosDeYT">
                  <picture className={theme.cardServiciosImg2}>
                    <img src="/img/ServiciosComercios.png" alt="/img/ServiciosComercios.png" />
                  </picture>
                </NavLink>

                <Typography variant="h6">Digitalización de eventos</Typography>

                <span className={theme.swiperSlideText}>
                  ¡Queremos que los asistentes a tu evento, vivan una experiencia inolvidable! A través de Real Travel app, puedes poner a disposición
                  el programa, expositores, pre y post tours, comercios asociados y sugerencia de rutas.
                </span>
              </div>
            </div>
          </Container>

          <div data-title="Celulares" className={theme.swiperPhoneDiv}>
            <div data-title="Title " className={theme.titleWhite}>
              <Typography variant="h1">
                EXPERIENCIA
                <span className={theme.titleRedLigth}>360º</span>
              </Typography>
            </div>

            <div data-title="Container Celulares" className={theme.swiperPhoneDivContainer}>
              <Hidden lgUp>
                <Carousel
                  className={theme.carouselCardsInstagram}
                  arrows={false}
                  showDots={true}
                  draggable
                  centerMode={true}
                  infinite={true}
                  swipeable={true}
                  minimumTouchDrag={50}
                  autoPlay={true}
                  autoPlaySpeed={2500}
                  pauseOnHover
                  rtl={false}
                  shouldResetAutoplay
                  renderButtonGroupOutside={false}
                  containerClass={theme.containerWithDots}
                  responsive={{
                    desktop: {
                      breakpoint: {
                        max: 5000,
                        min: 951,
                      },
                      items: 1,
                      slidesToSlide: 1,
                      partialVisibilityGutter: 40,
                    },
                    tablet: {
                      breakpoint: {
                        max: 950,
                        min: 521,
                      },
                      items: 1,
                      slidesToSlide: 1,
                      partialVisibilityGutter: 30,
                    },
                    mobile: {
                      breakpoint: {
                        max: 520,
                        min: 0,
                      },
                      items: 1,
                      slidesToSlide: 1,
                      partialVisibilityGutter: 20,
                    },
                  }}
                >
                  <div data-title="div mapa" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/imgMapa.png" alt="/img/imgMapa.png" width="279" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Descubre las historias locales</span>

                    <span className={theme.swiperSlideText}>
                      La App te cuenta en voz de los locales datos históricos, culturales, anécdotas y curiosidades, con acceso a audios, textos,
                      videos y más.
                    </span>
                  </div>

                  <div data-title="div rutas" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/imgRutas.png" alt="/img/imgRutas.png" width="310" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Planifica tus rutas a medida</span>

                    <span className={theme.swiperSlideText}>
                      Elige rutas según tu interés, tiempo de recorrido o cercanía para explorar el destino de forma personalizada.
                    </span>
                  </div>

                  <div data-title="div comercios" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/comercio.png" alt="/img/comercio.png" width="279" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Explora el comercio local</span>

                    <span className={theme.swiperSlideText}>
                      Encuentra cafés, tiendas, alojamiento, y más de acuerdo a tu ubicación, con información detallada, horarios y direcciones.
                    </span>
                  </div>
                </Carousel>
              </Hidden>

              <Hidden lgDown>
                <div data-title="div mapa" className={theme.eachPhone}>
                  <picture className={theme.swiperSlideImg}>
                    <img src="/img/mapaDos.png" alt="/img/mapaDos.png" width="433" height="690" />
                  </picture>
                  <span className={theme.swiperSlideTextBold}>Descubre las historias locales</span>

                  <span className={theme.swiperSlideText}>
                    La App te cuenta en voz de los locales datos históricos, culturales, anécdotas y curiosidades, con acceso a audios, textos, videos
                    y más.
                  </span>
                </div>

                <div data-title="div rutas" className={theme.eachPhone}>
                  <picture className={theme.swiperSlideImg}>
                    <img src="/img/imgRutas.png" alt="/img/imgRutas.png" width="330" height="600" />
                  </picture>
                  <span className={theme.swiperSlideTextBold}>Planifica tus rutas a medida</span>

                  <span className={theme.swiperSlideText}>
                    Elige rutas según tu interés, tiempo de recorrido o cercanía para explorar el destino de forma personalizada.
                  </span>
                </div>

                <div data-title="div comercios" className={theme.eachPhone}>
                  <picture className={theme.swiperSlideImg}>
                    <img src="/img/comercio.png" alt="/img/comercio.png" width="433" height="690" />
                  </picture>
                  <span className={theme.swiperSlideTextBold}>Explora el comercio local</span>

                  <span className={theme.swiperSlideText}>
                    Encuentra cafés, tiendas, alojamiento, y más de acuerdo a tu ubicación, con información detallada, horarios y direcciones.
                  </span>
                </div>
              </Hidden>
            </div>
          </div>
        </div>

        <div data-title="Transformamos experiencias" className={theme.transformamosExperiencias}>
          <Container className={theme.containerTransformamos} maxWidth="xl">
            <div data-title="Parallax" className={theme.parallax}>
              <Parallax
                parent={document.getElementById('app')}
                blur={{ min: 0, max: 0 }}
                bgImage="/img/parallaxTransformamos.png"
                bgImageAlt=""
                strength={500}
                style={{ height: '100vh', width: '100vw' }}
              >
                <div data-title="Title White" className={theme.titleWhite}>
                  <Typography variant="h1">
                    TRANFORMAMOS EN EXPERIENCIAS
                    <span className={theme.titleRedLigth}>LOS ATRACTIVOS TURÍSTICOS LOCALES</span>
                  </Typography>

                  <div data-title="div button Se Parte" className={theme.divButtonSeParte}>
                    <a target="_top" href="/JoinUs">
                      <Button color="primary" className={theme.buttonSeParte}>
                        Se Parte
                      </Button>
                    </a>
                  </div>
                </div>
              </Parallax>
            </div>
          </Container>
        </div>

        <div data-title="Nuestros Partners " className={theme.nuestrosPartners}>
          <Container className={theme.containerNuestrosPartners} maxWidth="xl">
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h1">
                <span className={theme.titleRedLigth}>NUESTROS</span>
                PARTNERS
              </Typography>
            </div>

            <div data-title="Partners Section" className={theme.sectionPartners}>
              <Carousel
                className={theme.carouselPartners}
                arrows={true}
                draggable
                infinite={true}
                swipeable={true}
                minimumTouchDrag={50}
                autoPlay={true}
                autoPlaySpeed={2500}
                pauseOnHover
                rtl={false}
                shouldResetAutoplay
                renderButtonGroupOutside={false}
                containerClass={theme.containerWithDots}
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 5000,
                      min: 951,
                    },
                    items: 4,
                    slidesToSlide: 2,
                    partialVisibilityGutter: 40,
                  },
                  tablet: {
                    breakpoint: {
                      max: 950,
                      min: 521,
                    },
                    items: 2,
                    slidesToSlide: 1,
                    partialVisibilityGutter: 30,
                  },
                  mobile: {
                    breakpoint: {
                      max: 520,
                      min: 0,
                    },
                    items: 1,
                    slidesToSlide: 1,
                    partialVisibilityGutter: 20,
                  },
                }}
              >
                {allCardsPartners.map((item, index) => {
                  return (
                    <React.Fragment key={'UiQ3uTnC_' + index}>
                      <div data-title="div cards section" className={theme.cardPartner}>
                        <a target="_blank" href={item.PartnerURL}>
                          <picture>
                            <img src={`img/${item.PartnerLogo}`} alt={`img/${item.PartnerLogo}`} draggable={false} />
                          </picture>
                        </a>
                      </div>
                    </React.Fragment>
                  )
                })}
              </Carousel>
            </div>
          </Container>
        </div>

        <div data-title="ODS" className={theme.sectionODS}>
          <Container className={theme.containerODS} maxWidth="xl">
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h1">
                NUESTROS
                <span className={theme.titleRedLigth}>ODS</span>
              </Typography>

              <Typography variant="body1">
                Real Travel trabaja con un propósito con impacto alineado a los ODS, específicamente el 17: Trabajar en alianza con otras entidades
                para alcanzar los otros 16 ODS
              </Typography>
            </div>

            <div data-title="div Img ODS" className={theme.divImgODS}>
              <picture>
                <img src="/img/ODS_General2.png" alt="/img/ODS_General2.png" />
              </picture>
            </div>
          </Container>
        </div>

        <div data-title="Encuentranos new" className={theme.encuentranos}>
          <Container className={theme.containerEncuentranos} maxWidth="xl">
            <div data-title="Title Red" className={theme.titleRed}>
              <Typography variant="h1">
                <span className={theme.titleRedLigth}>ENCUÉNTRANOS</span>
              </Typography>
            </div>

            <div data-title="div CardsInstagram" className={theme.instagramSection}>
              <Carousel
                className={theme.carouselCardsInstagram}
                arrows={false}
                showDots={true}
                draggable
                centerMode={true}
                infinite={true}
                swipeable={true}
                minimumTouchDrag={50}
                autoPlay={true}
                autoPlaySpeed={2500}
                pauseOnHover
                rtl={false}
                shouldResetAutoplay
                renderButtonGroupOutside={false}
                containerClass={theme.containerWithDots}
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 5000,
                      min: 951,
                    },
                    items: 4,
                    slidesToSlide: 2,
                    partialVisibilityGutter: 40,
                  },
                  tablet: {
                    breakpoint: {
                      max: 950,
                      min: 521,
                    },
                    items: 2,
                    slidesToSlide: 1,
                    partialVisibilityGutter: 30,
                  },
                  mobile: {
                    breakpoint: {
                      max: 520,
                      min: 0,
                    },
                    items: 1,
                    slidesToSlide: 1,
                    partialVisibilityGutter: 20,
                  },
                }}
              >
                {allCardsInstagram.map((item, index) => {
                  return (
                    <React.Fragment key={'MdoAfLIw_' + index}>
                      <a target="_blank" className={theme.linkInstagram} href={item.Link} draggable={false}>
                        <div data-title="div card Ig" className={theme.cardIg}>
                          <div data-title="div image" className={theme.cardIgDivImage}>
                            <picture className={theme.cardIgImage}>
                              <img src={`/img/${item.Image}`} alt={`/img/${item.Image}`} />
                            </picture>
                          </div>

                          <div data-title="div caption" className={theme.cardIgDivCaption}>
                            <Typography variant="h4">
                              <span className={theme.cardIgCaptiontitle}>{item.Name}</span>
                            </Typography>
                          </div>
                        </div>
                      </a>
                    </React.Fragment>
                  )
                })}
              </Carousel>
            </div>
          </Container>
        </div>
      </div>

      <div data-title="Footer Red" className={theme.footersRed}>
        <div data-title="div footer Left" className={theme.footerDivLeft}>
          <div data-title="div Img And Buttons Socials" className={theme.footerImgSocials}>
            <div data-title="div Img" className={theme.footerImg}>
              <picture>
                <img src="/img/RTLogo_blanco.svg" alt="/img/RTLogo_blanco.svg" />
              </picture>
            </div>

            <div data-title="div buttons socials" className={theme.footerButtonsSocials}>
              <a target="_blank" href="https://www.linkedin.com/company/realtravel/">
                <picture>
                  <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                </picture>
              </a>

              <a href="mailto:hola@realtravel.cl?subject=Email%20de%20contacto%20por%20&body=Hola!%20Me%20contacto%20desde%20el%20website%20de%20Real%20Travel%20para%3A%20">
                <picture>
                  <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.instagram.com/realtravelap/">
                <picture>
                  <img src="/img/LogoIntagram.svg" alt="/img/LogoIntagram.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.youtube.com/channel/UC535xN03fixDzJGFtVDAtvA/featured">
                <picture>
                  <img src="/img/logoYouTube.svg" alt="/img/logoYouTube.svg" />
                </picture>
              </a>
            </div>
          </div>

          <div data-title="div All rights reserved" className={theme.footerAllRightsReserved}>
            <Typography variant="body1">©2024 Real Travel. All rights reserved</Typography>
          </div>
        </div>

        <div data-title="div links" className={theme.footerDivCenter}>
          <NavLink to="/AboutUs">
            <Typography variant="h6">Quienes somos</Typography>
          </NavLink>

          <NavLink to="/JoinUs">
            <Typography variant="h6">Se parte</Typography>
          </NavLink>

          <NavLink to="/Press">
            <Typography variant="h6">Prensa</Typography>
          </NavLink>
        </div>

        <div data-title="Div Footer  Right" className={theme.footerDivRight}>
          <div data-title="div terms and conditions" className={theme.footerTermsAndConditions}>
            <NavLink to="/TermsAndConditions">
              <Typography variant="body1">Términos y condiciones</Typography>
            </NavLink>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
